<template>
    <v-layout row wrap>
        <v-flex>
            <div class="text-xs-left">
                <v-btn
                        flat
                        @click="goBack"
                >
                    <v-icon left small>fal fa-chevron-left</v-icon>
                    {{ $vuetify.t('$vuetify.back') }}
                </v-btn>
            </div>
        </v-flex>

        <v-flex xs12 v-if="cartItems.length > 0">
            <v-radio-group
                    class="shop-payment-choices"
                    :mandatory="true"
                    v-model="selectedPaymentOption">
                <v-list three-line subheader>
                    <div v-for="(option, index) in paymentOptions"
                         :key="index">
                        <v-card flat style="background: transparent" fill-height>
                            <v-card-actions>
                                <v-list-tile>
                                    <v-list-tile-avatar style="border-radius: 0">
                                        <v-radio :value=option.identifier></v-radio>
                                    </v-list-tile-avatar>
                                    <v-list-tile-avatar style="border-radius: 0">
                                        <OrdersPayment :paymentCode=Number(option.identifier)></OrdersPayment>
                                    </v-list-tile-avatar>

                                    <v-list-tile-content>
                                        <v-list-tile-title class="title font-weight-bold"> {{ option.title }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title v-if="option.text">
                                            {{ option.text }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                    <VuePhoneNumberInput v-if="Number(option.identifier) === 3 && displayPhoneNumber"
                                                         :dark="dark_theme" v-model="username"
                                                         :default-country-code="countryCode"
                                                         :preferred-countries="preferredCountryCodes"
                                                         required
                                                         :error="valid==false"
                                                         @update="defineSelectedCountryCode"/>
                            </v-card-actions>
                        </v-card>
                    </div>
                </v-list>
            </v-radio-group>

            <v-flex xs12>
                <div class="text-xs-center">
                    <v-btn
                            :disabled=!isEnabled
                            @click="submit"
                            class="primary"
                            large
                    >
                        {{ $vuetify.t('$vuetify.shop.shop_cart_checkout') }}
                        <v-icon right small>fal fa-angle-double-right</v-icon>
                    </v-btn>
                </div>
            </v-flex>

        </v-flex>

        <v-flex xs12 v-else>
            <v-layout align-center justify-center column>
                <v-spacer class="my-4"></v-spacer>
                <v-icon style="font-size: 150px">fal fa-shopping-cart</v-icon>
                <v-spacer class="my-4"></v-spacer>
                <h2 class="title text-xs-center">{{ $vuetify.t('$vuetify.shop.shop_cart_empty') }}</h2>
                <v-spacer class="my-4"></v-spacer>
                <div class="text-xs-center">
                    <v-btn
                            @click="goTo"
                            class="primary"
                            large
                    >
                        {{ $vuetify.t('$vuetify.shop.buy') }}
                        <v-icon right small>fal fa-angle-double-right</v-icon>
                    </v-btn>
                </div>
            </v-layout>
        </v-flex>
    </v-layout>
</template>


<script>
    import {mapGetters} from 'vuex';
    import {genericService} from '@/_services/shop/generic.service';
    import {getErrorMessage, recaptchaHelper} from '@/_helpers';
    import OrdersPayment from '@/components/shop/OrdersPayment.vue';

    import VuePhoneNumberInput from 'vue-phone-number-input';
    import 'vue-phone-number-input/dist/vue-phone-number-input.css';


    export default {
        name: "PaymentOptions",
        components: {VuePhoneNumberInput, OrdersPayment},
        data() {
            return {
                dark_theme: true,
                valid: true,
                locale: "pt",
                paymentOptions: [],
                selectedPaymentOption: null,
                username: null,
            }
        },
        methods: {
            /**
             * The method which sends to the backend the necessary data to create the Order.
             **/
            submit() {
                // 1 - setting the Loading Layer
                this.$store.dispatch("loader/setLoading", true);

                // 2 - an object is defined with all the information which will be passed to the backend
                let obj = {
                    "items": this.cartItems,
                    "shipping_method": this.deliveryInfo.method_key,
                    "shipping_pickup_store": this.deliveryInfo.store.code,
                    "date": this.date,
                    "hour": this.time,
                    "obs": this.obs,
                    "payment_method": this.selectedPaymentOption,
                    "payment_contact": this.username,
                    "payment_contact_prefix": this.selectedCountryCode
                };

                // 3 - sending the items on the Shopping Cart to create the Order on the backend
                // Once the Order is successfully created, the local storage is "cleaned" and
                // the user is redirected to the list of his Orders.
                recaptchaHelper('setCustomerPurchase', this).then((token) => {
                        obj.recaptcha_token = token;
                        genericService.setCustomerPurchase(obj).then(result => {
                                //Example of result: {'status': response_status,
                                //                    'error': error_code,
                                //                    'order': order_id,
                                //                    'payment': {'flow': X, 'entity': X, 'reference': X, 'redirect': X}}
                                if (result && result.status && result.status === 1 && result.payment) {
                                    this.$log.debug("Order Step Payment | Set Customer Purchase | " + result);
                                    if (result.payment.flow === 'redirect') {
                                        window.location.href = result.payment.redirect;
                                    } else if (result.payment.flow === 'display') {
                                        this.$router.push({
                                            'name': "order-complete", params: {
                                                order: result.order
                                            }
                                        })
                                    }
                                    this.$store.dispatch('shop/setShopCartEmpty');
                                    this.$store.dispatch('shop/setDeliveryOptionsEmpty');
                                } else if (result && result.status === 0 && result.error === "Err101") {
                                    this.$store.dispatch("alert/error", this.$vuetify.t('$vuetify.shop.exceeded_daily_orders'));

                                } else {
                                    this.$store.dispatch("alert/error", this.$vuetify.t('$vuetify.generic_error'));
                                }

                                this.$store.dispatch("loader/setLoading", false);
                            },
                            error => {
                                getErrorMessage(error, 'Set Customer Purchase', this);
                            });
                    },
                    error => {
                        getErrorMessage(error, 'Set Customer Purchase Recaptcha', this);
                    });
            },
            /**
             * The method assigned to the button which allows the user to return to the interface to choose the
             * Delivery Options
             **/
            goBack() {
                this.$router.push({name: "order-resume"});
            },
            /**
             *
             * @param payload: {
             * 	"countryCode": "FR",
             *  "isValid": true,
             *  "phoneNumber": "0665656565",
             *  "countryCallingCode": "33",
             *  "formattedNumber": "+33665656565",
             *  "nationalNumber": "665656565",
             *  "formatInternational": "+33 6 65 65 65 65",
             *  "formatNational": "06 65 65 65 65",
             *  "uri": "tel:+33665656565",
             *  "e164": "+33665656565"
             *  }
             */
            defineSelectedCountryCode(payload) {
                this.selectedCountryCode = payload.countryCallingCode
            },
        },
        computed: {
            /**
             * The button which allows the user to submit the order, should be disabled until the User
             * selects the Payment method.
             * @returns {boolean}
             */
            isEnabled() {
                return !!this.selectedPaymentOption;
            },
            /**
             * The Phone Number input is displayed only if the User uses the MbWay Payment method.
             * @returns {boolean}
             */
            displayPhoneNumber() {
                return Number(this.selectedPaymentOption) === 3;

            },
            ...mapGetters({
                cartItems: 'shop/cartItems',
                cartTotalItems: 'shop/cartSize',
                cartTotalAmount: 'shop/cartTotalAmount',
                deliveryInfo: 'shop/deliveryInfo',
                countryCode: 'configs/countryCode',
                preferredCountryCodes: 'configs/preferredCountryCodes',
            })
        },
        mounted() {
            this.$store.dispatch("loader/setLoading", true);

            this.date = this.$route.params.date;
            this.hour = this.$route.params.hour;
            this.obs = this.$route.params.obs;

            this.dark_theme = process.env.VUE_APP_VUETIFY_DARK_THEME === "True";

            this.username = this.$store.state.authentication.user.username.split('-')[1];

            genericService.getPaymentOptions().then(result => {
                    this.paymentOptions = result.results[0].payment_methods;
                    this.$store.dispatch("loader/setLoading", false);
                },
                error => {
                    getErrorMessage(error, 'Getting the Payment Options', this);
                }
            );

            this.locale = process.env.VUE_APP_LANG;
        }
    }
</script>

<style scoped>

</style>